const UserIcon = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width='14'
    height='14'
    viewBox='0 0 14 14'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g id='Icon/people'>
      <g id='Vector'>
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M4.66667 8.45833C2.89475 8.45833 1.45833 9.89475 1.45833 11.6667C1.45833 12.1499 1.85008 12.5417 2.33333 12.5417H11.6667C12.1499 12.5417 12.5417 12.1499 12.5417 11.6667C12.5417 9.89475 11.1052 8.45833 9.33333 8.45833H4.66667ZM0.875 11.6667C0.875 9.57259 2.57259 7.875 4.66667 7.875H9.33333C11.4274 7.875 13.125 9.57259 13.125 11.6667C13.125 12.4721 12.4721 13.125 11.6667 13.125H2.33333C1.52792 13.125 0.875 12.4721 0.875 11.6667Z'
          fill='currentColor'
        />
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M7 1.45833C5.55025 1.45833 4.375 2.63359 4.375 4.08333C4.375 5.53308 5.55025 6.70833 7 6.70833C8.44975 6.70833 9.625 5.53308 9.625 4.08333C9.625 2.63359 8.44975 1.45833 7 1.45833ZM3.79167 4.08333C3.79167 2.31142 5.22809 0.875 7 0.875C8.77191 0.875 10.2083 2.31142 10.2083 4.08333C10.2083 5.85525 8.77191 7.29167 7 7.29167C5.22809 7.29167 3.79167 5.85525 3.79167 4.08333Z'
          fill='currentColor'
        />
      </g>
    </g>
  </svg>
)

export default UserIcon
